import { defineComponent as _defineComponent } from 'vue'
import { BackButton } from '@/modules/common/components/buttons';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  BaseText,
  BrandImage,
  ButtonContainer,
  ButtonIconContextual,
  ButtonPrimary,
  ContextColorProvider,
  EBrandImageLogos,
  EBrandImageSchemas,
  Heading,
  HelperViewStatus,
  InitialAvatarIcon,
  NavBar,
  SpinnerLoader
} from '@warrenbrasil/nebraska-web';
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router/composables';
import { SideSheetTerm } from '@/modules/trade/views/PaidCustody/components/PaidCustodyActive/components/SideSheetTerm';
import { ModalPassword } from '@/modules/trade/views/PaidCustody/components/ModalPassword';
import { Splash } from '@/modules/trade/views/PaidCustody/components/PaidCustodyActive/components/Splash';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';
import {
  getPaidCustody,
  PaidCustody
} from '@/modules/trade/services/paid-custody';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaidCustodyActive',
  props: {
    hasError: { type: Boolean },
    loadingPassword: { type: Boolean }
  },
  emits: ['has-error', 'go-to-next-step'],
  setup(__props: any, { emit }) {

const { hasError, loadingPassword } = __props as {
  hasError: boolean;
  loadingPassword: boolean;
};



const router = useRouter();
const showSideSheet = ref(false);
const showModalPassword = ref(false);
const paidCustody = ref<PaidCustody | null>(null);
const loading = ref(false);



const handleCloseModal = () => {
  showSideSheet.value = false;
};

const handleNextClick = () => {
  if (hasError) {
    router.push({ name: 'trade' });

    return notify({
      group: 'wrn-notifications',
      text: 'Houve um erro ao desativar a custódia remunerada. Tente novamente em alguns minutos.',
      type: NotificationTypes.error
    });
  }

  showSideSheet.value = true;
};

const handleOpenModalPassword = () => {
  showModalPassword.value = true;
};

const handleCloseModalPassword = () => {
  showModalPassword.value = false;
};

const handleFrequentlyAskedQuestions = () => {
  return router.push({ name: 'faq' });
};

const triggerError = () => {
  emit('has-error', true);
};

const goToNextStep = () => {
  emit('go-to-next-step');
};

const fetchPaidCustody = async () => {
  emit('has-error', false);

  try {
    loading.value = true;

    const response = await getPaidCustody();

    paidCustody.value = response;
  } catch (e) {
    triggerError();
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  fetchPaidCustody();
});

return { __sfc: true,router, showSideSheet, showModalPassword, paidCustody, loading, emit, handleCloseModal, handleNextClick, handleOpenModalPassword, handleCloseModalPassword, handleFrequentlyAskedQuestions, triggerError, goToNextStep, fetchPaidCustody, BackButton, NebraskaColors, BaseText, BrandImage, ButtonContainer, ButtonIconContextual, ButtonPrimary, ContextColorProvider, EBrandImageLogos, EBrandImageSchemas, Heading, HelperViewStatus, InitialAvatarIcon, NavBar, SpinnerLoader, SideSheetTerm, ModalPassword, Splash }
}

})